import React, { ReactElement, PropsWithChildren } from 'react'
import { Flex, ThemeUIStyleObject } from 'theme-ui'

export function MainContentContainer({
  children,
  sxContainer,
}: PropsWithChildren<{ sxContainer?: ThemeUIStyleObject }>): ReactElement {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        borderRadius: '1.2rem',
        border: '1px solid',
        borderColor: 'blueYonder50',
        backgroundColor: 'blue80',
        overflow: 'hidden',
        zIndex: 'zIndex5',
        mb: '4rem',
        ...sxContainer,
      }}
    >
      {children}
    </Flex>
  )
}
